import React from 'react'
import NewConvoHeader from 'components/App/DesktopView/shared/NewConvoHeader'
import styled from '@emotion/styled'
import themeVars from 'ui_theme/site/globals/site.variables'

import LogConvoForm from './LogConvoForm'

const FormContainer = styled('div')`
  background-color: ${props => props.theme.color.secondary.warning};
  height: 100%;
  padding-top: ${themeVars.massive};
  padding-left: ${props => props.theme.spacing['12']};
  padding-bottom: ${props => props.theme.spacing['6']};
  padding-right: ${props => props.theme.spacing['12']};
  overflow: auto;
`
export default function LogConversationPage({ draft }) {
  return (
    <React.Fragment>
      <NewConvoHeader isLogging />
      <FormContainer>
        <LogConvoForm draft={draft} />
      </FormContainer>
    </React.Fragment>
  )
}
